import { useState } from 'react';

import { getItem, setItem } from 'hb-react/shared/utils/sessionStorage';

const STORAGE_KEY = 'ATTACHED_IMAGES_FITTED_HEIGHTS';

const useSessionStorageAttachedImages = () => {
  const defaultValue = {};

  const [storedValue, setStoredValue] = useState(() => {
    try {
      const value = getItem({ key: STORAGE_KEY });

      if (value) {
        return value;
      }

      setItem({ key: STORAGE_KEY, value: defaultValue });

      return defaultValue;
    } catch (_err) {
      return defaultValue;
    }
  });

  const setValue = (newValue) => {
    try {
      setItem({ key: STORAGE_KEY, value: newValue });
      // eslint-disable-next-line no-empty
    } catch (_err) {}
    setStoredValue(newValue);
  };

  return [storedValue, setValue];
};

export default useSessionStorageAttachedImages;
